/* AspireArtisans "My warranty": lists registrations from GET /mine and sends problem reports.
   Photos and videos upload straight to Shopify storage; the API only signs the upload and records the report. */
(function () {
  'use strict';
  var root = document.querySelector('[data-aaw-account]');
  if (!root) return;
  var API = root.getAttribute('data-api');
  var loginToken = root.getAttribute('data-token') || '';
  var KEY = 'aaw_link_token';
  var $ = function (s) { return root.querySelector(s); };
  var MB = { 'image/jpeg': 10, 'image/png': 10, 'image/heic': 10, 'image/webp': 10, 'video/mp4': 20, 'video/quicktime': 20 };
  var EXT = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', heic: 'image/heic', webp: 'image/webp', mp4: 'video/mp4', mov: 'video/quicktime' };
  var ISSUES = [['missing_part', 'A part is missing'], ['damaged', 'Damaged or broken'], ['not_working', 'Does not work as expected'], ['other', 'Something else']];
  var STATUS = { submitted: 'Received', reviewing: 'Being reviewed', resolved: 'Resolved', rejected: 'Answered' };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function day(ymd) {
    var p = String(ymd || '').split('-');
    if (p.length !== 3) return ymd || '';
    return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
  }
  function mime(f) { return String(f.type || '').toLowerCase() || EXT[String(f.name || '').split('.').pop().toLowerCase()] || ''; }
  function badFile(f) {
    var mb = MB[mime(f)];
    if (!mb) return 'Photos (JPG, PNG, HEIC, WEBP) or videos (MP4, MOV) only.';
    if (!(f.size > 0) || f.size > mb * 1048576) return (mb === 10 ? 'Photos' : 'Videos') + ' must be under ' + mb + ' MB.';
    return '';
  }
  function api(path, body) {
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {};
    return fetch(API + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!j || !j.success) { var e = new Error((j && j.error) || 'Something went wrong. Please try again.'); e.field = j && j.field; throw e; }
        return j.data;
      });
    });
  }

  // Take the email-link token out of the address bar right away (history, screenshots, Referer).
  var params = new URLSearchParams(location.search);
  var linkToken = params.get('t') || '';
  try {
    if (linkToken) sessionStorage.setItem(KEY, linkToken); else linkToken = sessionStorage.getItem(KEY) || '';
    if (params.has('t')) history.replaceState(null, '', location.pathname);
  } catch (e) { /* storage blocked */ }
  var token = loginToken || linkToken;

  // A signed-in token lives 15 minutes: if it ran out while a report was being written, get a fresh one and retry once.
  function refresh() {
    return fetch(location.pathname, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.text(); }).then(function (h) {
      var m = /data-aaw-account[^>]*?data-token="([^"]*)"/.exec(h);
      if (m && m[1]) { loginToken = token = m[1]; }
      return m ? m[1] : '';
    }).catch(function () { return ''; });
  }
  function authed(make) {
    return api.apply(null, make(token)).catch(function (err) {
      if (err.field !== 'token' || !loginToken) throw err;
      return refresh().then(function (t) { if (!t) throw err; return api.apply(null, make(t)); });
    });
  }

  var data = null;
  var report = null; // { ref, items, item, issue, text, files: [{file,name,state,resourceUrl,ticket}], busy, error, done }

  function guest(msg) {
    $('[data-aaw-list]').innerHTML = '';
    $('[data-aaw-guest]').hidden = false;
    if (msg) $('[data-aaw-guest-msg]').textContent = msg;
  }

  function itemCard(w, i) {
    var label = { active: 'Covered', pending: 'Being verified', expired: 'Ended' }[w.status] || w.status;
    var claims = (w.claims || []).length ? '<ul class="aaw-claims">' + w.claims.map(function (c) {
      return '<li>Report ' + esc(c.claimNo) + ' · ' + esc(c.item) + ' · <strong>' + esc(STATUS[c.status] || c.status) + '</strong>' +
        (c.resolution ? '<br><span class="aaw-small">' + esc(c.resolution) + '</span>' : '') + '</li>';
    }).join('') + '</ul>' : '';
    var canReport = w.status === 'active' || w.status === 'expired';
    return '<article class="aaw-item">' +
      '<h3>' + w.items.map(function (x) { return esc(x.name); }).join(', ') + '<span class="aaw-status is-' + esc(w.status) + '">' + esc(label) + '</span></h3>' +
      '<dl class="aaw-facts">' +
        '<div><dt>Order</dt><dd>' + esc(w.orderNumber) + '</dd></div>' +
        (w.purchaseDate ? '<div><dt>Purchased</dt><dd>' + esc(day(w.purchaseDate)) + '</dd></div>' : '') +
        (w.coverageEnd ? '<div><dt>Covered until</dt><dd><strong>' + esc(day(w.coverageEnd)) + '</strong></dd></div>' : '') +
        '<div><dt>Reference</dt><dd>' + esc(w.ref) + '</dd></div>' +
      '</dl>' + claims +
      (w.status === 'pending' ? '<p class="aaw-small">We are still checking this order. You can report a problem as soon as it is confirmed, or email support@aspireartisans.com now.</p>' : '') +
      (canReport ? '<div class="aaw-row" style="margin-top:1.2rem"><button type="button" class="aaw-btn aaw-btn--line" data-aaw-report="' + i + '">Report a problem</button></div>' : '') +
      (report && report.index === i ? reportForm() : '') +
      '</article>';
  }

  function filesHtml() {
    return report.files.map(function (f, k) {
      var s = f.state === 'done' ? 'Uploaded' : f.state === 'failed' ? (esc(f.error) + ' <button type="button" class="aaw-linkbtn" data-aaw-retry="' + k + '">Retry</button>') : 'Uploading…';
      return '<li><span>' + esc(f.name) + ' · ' + s + '</span><button type="button" class="aaw-linkbtn" data-aaw-remove="' + k + '">Remove</button></li>';
    }).join('');
  }
  // Upload progress only touches the file list, so typing in the description is never interrupted.
  function drawFiles() {
    var ul = root.querySelector('.aaw-report .aaw-files');
    if (ul && report) ul.innerHTML = filesHtml(); else if (report) { readForm(); draw(); }
  }

  function reportForm() {
    var r = report;
    if (r.done) return '<div class="aaw-report"><div class="aaw-found" role="status"><p><strong>Report ' + esc(r.done) + ' received.</strong></p><p>We emailed you a copy. A person on our team will reply within 1 business day.</p></div></div>';
    var items = r.items.length > 1 ? '<p class="aaw-label">Which product?</p><div class="aaw-radio">' + r.items.map(function (x) {
      var v = x.sku || x.name;
      return '<label><input type="radio" name="aaw-item" value="' + esc(v) + '"' + (r.item === v ? ' checked' : '') + '> ' + esc(x.name) + '</label>';
    }).join('') + '</div>' : '';
    var files = filesHtml();
    return '<div class="aaw-report">' + items +
      '<p class="aaw-label">What went wrong?</p><div class="aaw-radio">' + ISSUES.map(function (o) {
        return '<label><input type="radio" name="aaw-issue" value="' + o[0] + '"' + (r.issue === o[0] ? ' checked' : '') + '> ' + o[1] + '</label>';
      }).join('') + '</div>' +
      '<div class="aaw-field"><label class="aaw-label" for="aaw-text">Tell us in a sentence or two</label>' +
      '<textarea class="aaw-input" id="aaw-text" rows="4" maxlength="2000">' + esc(r.text) + '</textarea></div>' +
      '<div class="aaw-field"><label class="aaw-label" for="aaw-files">Photos or a short video (1–5)</label>' +
      '<input class="aaw-input" id="aaw-files" type="file" accept="image/jpeg,image/png,image/heic,image/webp,video/mp4,video/quicktime" multiple>' +
      '<ul class="aaw-files">' + files + '</ul></div>' +
      (r.error ? '<p class="aaw-error" role="alert">' + esc(r.error) + '</p>' : '') +
      '<div class="aaw-row"><button type="button" class="aaw-btn" style="width:auto" data-aaw-send' + (r.busy ? ' disabled' : '') + '>' + (r.busy ? 'Sending…' : 'Send report') + '</button>' +
      '<button type="button" class="aaw-linkbtn" data-aaw-cancel>Cancel</button></div></div>';
  }

  function draw() {
    var ws = data.warranties || [];
    $('[data-aaw-hello]').textContent = 'Hi ' + (data.firstName || 'there') + ', here is your coverage.';
    $('[data-aaw-lead]').textContent = ws.length ? 'Registered products, how long each one is covered, and any problem reports.' : 'No registered products on this email yet.';
    $('[data-aaw-list]').innerHTML = ws.length ? ws.map(itemCard).join('')
      : '<div class="aaw-panel"><p>Register a product to extend its warranty from 1 to 3 years.</p><a class="aaw-btn" href="/pages/free-extended-warranty">Register a product</a></div>';
    var extra = '';
    if (data.offer && data.offer.kind === 'coupon') {
      extra += '<div class="aaw-code"><span class="aaw-small">Your thank-you code, 10% off one order, until ' + esc(new Date(data.offer.endsAt).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })) + '</span><b>' + esc(data.offer.code) + '</b>' +
        '<a href="/discount/' + encodeURIComponent(data.offer.code) + '?redirect=%2Fcollections%2Fall">Shop with the code applied</a></div>';
    }
    if ((data.recommendations || []).length) {
      extra += '<h2>' + esc(data.recommendationTitle || 'From our workshop') + '</h2><ul class="aaw-claims">' + data.recommendations.slice(0, 3).map(function (p) {
        return '<li><a href="/products/' + encodeURIComponent(p.handle) + '">' + esc(p.title) + '</a> <span class="aaw-small">' + esc(p.price) + '</span></li>';
      }).join('') + '</ul>';
    }
    $('[data-aaw-extra]').innerHTML = extra;
  }

  function load() {
    if (!token) { guest(''); return; }
    $('[data-aaw-list]').innerHTML = '<p class="aaw-small">Loading your warranty…</p>';
    api('/mine?t=' + encodeURIComponent(token)).then(function (d) {
      if ((!d || !d.valid) && loginToken) return refresh().then(function (t) { return t ? api('/mine?t=' + encodeURIComponent(t)) : d; });
      return d;
    }).then(function (d) {
      if (!d || !d.valid) {
        if (!loginToken) { try { sessionStorage.removeItem(KEY); } catch (e) {} }
        guest(loginToken ? 'We could not load your warranty just now. Please refresh the page.' : 'This link has expired. Enter your order number and we will email a new one.');
        return;
      }
      data = d;
      draw();
    }).catch(function () { guest('We could not load your warranty just now. Please try again in a minute.'); });
  }

  function upload(f) {
    f.state = 'uploading';
    drawFiles();
    return authed(function (t) { return ['/claim/uploads', { t: t, files: [{ name: f.name, mime: mime(f.file), size: f.file.size }] }]; }).then(function (r) {
      var tg = r.targets[0];
      var fd = new FormData();
      tg.parameters.forEach(function (p) { fd.append(p.name, p.value); });
      fd.append('file', f.file);
      return fetch(tg.url, { method: 'POST', body: fd }).then(function (res) {
        if (!res.ok && res.status !== 201 && res.status !== 204) throw new Error('Upload failed (' + res.status + ')');
        f.resourceUrl = tg.resourceUrl; f.ticket = tg.ticket; f.state = 'done';
      });
    }).catch(function (e) { f.state = 'failed'; f.error = e.message || 'Upload failed'; }).then(function () { if (report) drawFiles(); });
  }

  function readForm() {
    if (!report) return;
    var t = root.querySelector('#aaw-text');
    if (t) report.text = t.value;
    var it = root.querySelector('input[name="aaw-item"]:checked');
    if (it) report.item = it.value;
    var is = root.querySelector('input[name="aaw-issue"]:checked');
    if (is) report.issue = is.value;
  }

  function problem() {
    var r = report;
    if (!r.item) return 'Please choose the product.';
    if (!r.issue) return 'Please choose what went wrong.';
    if (r.text.trim().length < 10) return 'Please describe the problem in a sentence or two.';
    if (!r.files.length) return 'Please add at least one photo or video.';
    if (r.files.some(function (f) { return f.state === 'uploading'; })) return 'Please wait for the uploads to finish.';
    if (r.files.some(function (f) { return f.state !== 'done'; })) return 'One file did not upload. Retry it or remove it.';
    return '';
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    if (b.hasAttribute('data-aaw-report')) {
      var i = +b.getAttribute('data-aaw-report');
      var w = data.warranties[i];
      report = { index: i, ref: w.ref, items: w.items, item: w.items.length === 1 ? (w.items[0].sku || w.items[0].name) : '', issue: '', text: '', files: [], busy: false, error: '', done: '' };
      draw();
      var first = root.querySelector('.aaw-report input, .aaw-report textarea');
      if (first) first.focus();
      return;
    }
    if (!report) return;
    readForm();
    if (b.hasAttribute('data-aaw-cancel')) { report = null; draw(); return; }
    if (b.hasAttribute('data-aaw-remove')) { report.files.splice(+b.getAttribute('data-aaw-remove'), 1); draw(); return; }
    if (b.hasAttribute('data-aaw-retry')) { upload(report.files[+b.getAttribute('data-aaw-retry')]); return; }
    if (b.hasAttribute('data-aaw-send')) {
      report.error = problem();
      if (report.error) { draw(); return; }
      report.busy = true;
      draw();
      var r = report;
      authed(function (t) {
        return ['/claim', { t: t, ref: r.ref, item: r.item, issueType: r.issue, description: r.text,
          files: r.files.map(function (f) { return { resourceUrl: f.resourceUrl, ticket: f.ticket, mime: mime(f.file) }; }) }];
      }).then(function (res) { r.done = res.claimNo; }).catch(function (err) { r.error = err.message; })
        .then(function () { r.busy = false; draw(); });
    }
  });

  root.addEventListener('change', function (e) {
    if (!report || e.target.id !== 'aaw-files') return;
    readForm();
    report.error = '';
    Array.prototype.slice.call(e.target.files).forEach(function (file) {
      if (report.files.length >= 5) { report.error = 'You can add up to 5 files.'; return; }
      var bad = badFile(file);
      if (bad) { report.error = file.name + ': ' + bad; return; }
      var f = { file: file, name: file.name, state: 'uploading' };
      report.files.push(f);
      upload(f);
    });
    draw();
  });

  var linkForm = $('[data-aaw-link-form]');
  if (linkForm) linkForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = $('#aaw-link-order').value.trim();
    var msg = $('[data-aaw-link-msg]');
    if (!v) { msg.textContent = 'Please enter your order number.'; return; }
    msg.textContent = 'Sending…';
    api('/resend', { order: v }).then(function () {
      msg.textContent = 'If this order is registered, a new link is on its way to the email used. Check spam if it is not there in 10 minutes.';
    }).catch(function (err) { msg.textContent = err.message; });
  });

  load();
})();
